(function () {
  'use strict';

  const parsePrice = (value) => {
    const parsed = Number.parseFloat(String(value || '').replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const formatPrice = (value) => {
    const formatted = String(value || '').trim();
    return formatted ? formatted.replace(/\.00$/, '') : 'Price unavailable';
  };

  const sizeLabel = (variant) => {
    const length = Number(variant && variant.size && variant.size.length || 0);
    const width = Number(variant && variant.size && variant.size.width || 0);
    if (length > 0 && width > 0) return `${length} x ${width}cm`;
    return String(variant && variant.title || 'Size details unavailable');
  };

  const normalizeProduct = (product) => ({
    title: String(product && product.title || ''),
    handle: String(product && product.handle || '').replace(/^\/products\//, '').split('?')[0],
    total_sizes: Number(product && product.total_sizes || 0),
    variants: Array.isArray(product && product.variants) ? product.variants : []
  });

  const isSale = (variant) => parsePrice(variant.compare_at_price) > parsePrice(variant.price);

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  const renderVariant = (variant, currencySymbol) => {
    const item = createElement('li', 'lr-size-price-viewer__variant');
    if (variant.available === false) item.classList.add('lr-size-price-viewer__variant--sold-out');

    const size = createElement('div');
    size.appendChild(createElement('span', 'lr-size-price-viewer__variant-size', sizeLabel(variant)));
    if (variant.available === false) {
      size.appendChild(createElement('span', 'lr-size-price-viewer__variant-meta', 'Sold out'));
    }

    const price = createElement('div', 'lr-size-price-viewer__variant-price');
    const current = `${currencySymbol}${formatPrice(variant.price)}`;
    if (isSale(variant)) {
      const rrp = createElement('del', 'lr-size-price-viewer__rrp', `RRP ${currencySymbol}${formatPrice(variant.compare_at_price)}`);
      price.appendChild(rrp);
      price.appendChild(createElement('strong', 'lr-size-price-viewer__sale-price', current));
    } else {
      price.appendChild(createElement('span', '', current));
    }

    item.appendChild(size);
    item.appendChild(price);
    return item;
  };

  const openViewer = (detail) => {
    const viewer = document.querySelector('[data-lr-size-price-viewer]');
    if (!viewer || !detail || !detail.opener) return;

    const product = normalizeProduct(detail.product);
    if (product.total_sizes <= 1 || product.variants.length <= 1) return;

    const title = viewer.querySelector('[data-lr-size-price-title]');
    const variants = viewer.querySelector('[data-lr-size-price-variants]');
    const productLink = viewer.querySelector('[data-lr-size-price-product-link]');
    const currencySymbol = viewer.getAttribute('data-currency-symbol') || '\u00A3';
    if (!title || !variants || !productLink) return;

    title.textContent = product.title;
    variants.replaceChildren();
    product.variants.forEach((variant) => variants.appendChild(renderVariant(variant, currencySymbol)));
    productLink.href = `/products/${encodeURIComponent(product.handle)}`;
    viewer.show(detail.opener);
    const closeButton = viewer.querySelector('.lr-size-price-viewer__close');
    if (closeButton) closeButton.focus();
  };

  const parseServerPayload = (trigger) => {
    const dataNode = trigger.parentElement && trigger.parentElement.querySelector('[data-lr-size-price-data]');
    if (!dataNode) return null;
    try {
      return JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('Unable to read size and price data for product card.', error);
      return null;
    }
  };

  const init = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-lr-size-price-trigger]');
      if (!trigger) return;
      const product = parseServerPayload(trigger);
      if (!product) return;
      event.preventDefault();
      openViewer({ product, opener: trigger });
    });

    document.addEventListener('lr:size-price:open', (event) => openViewer(event.detail));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
